import { render, staticRenderFns } from "./goods-in-review-list.vue?vue&type=template&id=50eb2b34&"
import script from "./goods-in-review-list.vue?vue&type=script&lang=js&"
export * from "./goods-in-review-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports